import { ThemeUICSSObject } from '@apia/theme';

export const message: ThemeUICSSObject = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  '.closeButton': {
    borderRadius: '5px',
    right: '0px',
    top: '-2px',
    zIndex: '15',
    position: 'absolute',
    variant: 'buttons.icon-outline-danger',
  },

  genericBox: {
    margin: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
  },

  fileName: {
    bottom: '4px',
    right: '4px',
    fontSize: '12px',
    color: '#333',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: 'inherit',
    textAlign: 'center',
    px: '5px',
  },

  textBox: {
    variant: 'layout.common.components.aiMessage.genericBox',
    width: '50px',
    padding: '10px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    position: 'relative',
  },

  textSnippet: {
    bottom: '4px',
    right: '4px',
    fontSize: '12px',
    color: '#555',
  },
};
